import React from 'react'

// Components
import CtaDefault from 'components/flex/Cta/CtaDefault'
import CtaPerson from 'components/flex/Cta/CtaPerson'

interface CtaShellProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPost_Flexcontent_Flex_Banner
  location?: any
}

interface CtaProps {
  [key: string]: any
}

const CtaShell: React.FC<CtaShellProps> = ({ fields, location = {} }) => {
  const cta: CtaProps = {
    default: CtaDefault,
    person: CtaPerson,
  }

  if (!fields.styletype || !cta[fields.styletype]) {
    return null
  }

  const Component = cta[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default CtaShell
